module.exports = __webpack_public_path__ + "img/prize0_active.579c2bf.png";